import React from 'react';
import './styles.css';

import P from 'prop-types';
import { LabelPreco } from '../../components/LabelPreco';

export const Obrigatorios = ({ data = {}, action }) => {
  let check = 'brightness_1';
  let color = '#F2F2F2';

  if (data.Produto.quantidade > 0) {
    check = 'radio_button_checked';
    color = '#EA1D2C';
  }

  return (
    <span className="montagem_container" onClick={action}>
      <div className="montagem_descricao">
        {data.Produto.descricao.toLowerCase()}
        {data.Produto.obs_produto !== '' && (
          <span className="montagem_observacao">{data.Produto.obs_produto.toLowerCase()}</span>
        )}
        {data.TipoMontagem != 'COMBO' && data.Produto.preco_app > 0 && (
          <LabelPreco className="montagem_preco" price={data.Produto.preco_app} />
        )}
      </div>
      <i className="material-icons" style={{ color: color, paddingRight: '15px' }}>
        {check}
      </i>
    </span>
  );
};

Obrigatorios.propTypes = {
  data: P.object,
  action: P.func,
};
